// Pasting a whole sheet imports it, into the Watchlist or the Actual
// Portfolio. A pasted block whose first row names one of the import's
// identifier columns (Ticker, ISIN, CUSIP, ...) goes through the same import
// as an uploaded file: the column check, the review and Apply. In the
// Watchlist anything else is a cell paste.

import Papa from 'papaparse';
import {
    MSI_V2_STAGED_IDENTIFIER_COLUMNS,
    PORTFOLIO_IDENTIFIER_COLUMNS,
    detectIdentifierColumns,
} from '../../config/UploadConstant';

export const PASTED_SHEET_FILE_NAME = 'Pasted sheet.csv';

// The identifier columns each import recognises.
const IDENTIFIER_COLUMNS_BY_DESTINATION = {
    watchlist: MSI_V2_STAGED_IDENTIFIER_COLUMNS,
    portfolio: PORTFOLIO_IDENTIFIER_COLUMNS,
};

function isBlankRow(cells) {
    return !Array.isArray(cells) || cells.every((cell) => String(cell ?? '').trim() === '');
}

/**
 * True when the pasted rows are a sheet the destination's import ('watchlist'
 * or 'portfolio') can read: like the server, skip blank rows at the top; the
 * first other row is the header.
 */
export function isPastedSheet(rows, destination) {
    if (!Array.isArray(rows)) return false;
    const headerIndex = rows.findIndex((cells) => !isBlankRow(cells));
    if (headerIndex < 0 || headerIndex >= rows.length - 1) return false;
    return detectIdentifierColumns(rows[headerIndex], IDENTIFIER_COLUMNS_BY_DESTINATION[destination]).length > 0;
}

/**
 * The pasted rows as a CSV file. The import reads CSV cells as text, so
 * identifiers keep their leading zeros and cells keep commas and line breaks.
 */
export function pastedSheetFile(rows, name = PASTED_SHEET_FILE_NAME) {
    return new File([Papa.unparse(rows)], name, { type: 'text/csv' });
}
